<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="区域审核" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="退货入库仓" >
                <el-select v-model="formData.inWarehouseId" style="width:10vw!important;" :disabled="able"
                  clearable>
                  <el-option v-for="item in warehouseList" :key="item.id" :label="item.warehouseName + '(' + item.warehouseCode +')'"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" :diabled="siteAppealButton" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf'],
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
  },
  data() {
    return {
      warehouseList: [],
      exchangeNo: '',

      siteAppealButton: false,

      formData: {
        id: null,
        processId: null,
        taskId: null,
        inWarehouseId: null,
        messageContent:null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    loadWarehouse() {
			this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
			}).then(res => {
				this.warehouseList = res.data.data
        if (this.warehouseList && this.warehouseList.length > 0) {
          let currentCode = "4904" // 4910改为4904
          // let currentCode = "CK-001"
          this.warehouseList.forEach(item => {
            console.log("currentCode" + currentCode)
            console.log("item.warehouseCode" + item.warehouseCode)
            if (currentCode === item.warehouseCode) {
              this.formData.inWarehouseId = item.id
            }
          })
        }
			})


		},


    // 考核的确认
    siteAppeal() {
      if (!this.formData.inWarehouseId) {
        this.$message.error('入库仓必填')
        return false;
      }
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: "/basic/wkExchangeBill/areaCheck",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('确认成功')
          this.$emit('closeD')
          this.$emit('flushed')
        }).catch(() => {
          this.$mask.close()
        })
      });
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("处理方案名称").then(res => {
        this.dealWayList = []
        res.data.data.forEach(item => {
          this.dealWayList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadWarehouse()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
